import LogisticsCompany from "@/enum/LogisticsCompany";
import { post } from "@/services/http/platformServer";

interface KsOrderExpressRecommendResult {
    /**
     * 订单原始 ID
     */
    orderOriginalId?: string;
    /**
     * 推荐的快递公司列表
     */
    recommendExpressList?: KsRecommendedExpress[];
}

export interface KsRecommendedExpress {
    /**
     * 快递公司
     */
    logisticsCompany?: LogisticsCompany;
    /**
     * 是否平台强制
     */
    platformForce?: boolean;
    /**
     * 是否可达
     */
    reachable?: boolean;
    /**
     * 推荐理由
     */
    recommendReason?: string;
}

export function getKsRecommendLogistics(shopId: number, orderOriginalIds: string[]) {
    return post<KsOrderExpressRecommendResult[]>(
        shopId,
        "/kwaishop/logistics/express/recommend",
        {
            shopId,
            orderOriginalIds,
        },
        { hideModal: true },
    );
}
